<template>
  <v-row justify="center">
    <v-dialog v-model="attivo" persistent max-width="600px">
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h5"
              >{{ $t("login.recuperoPassword") }}</span
            >
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    prepend-icon="mdi-email"
                    :label="$t('login.recuperoPasswordLabel')"
                    :rules="[rules.required, rules.email]"
                    v-model="form.email"
                    required
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  v-if="confermaReset"
                  class="animate__animated animate__fadeIn"
                >
                  <v-alert dense text type="success">{{
                    $t("login.confermaReset")
                  }}</v-alert>
                </v-col>
              </v-row>
            </v-container>
            <small>({{ $t("campiObbligatori") }})</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              prepend-icon="mdi-email"
              color="primary"
              
              @click="resetPassword"
            >
              {{ $t("login.recupera") }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="chiudi">
              {{ $t("chiudi") }}
            </v-btn>
          </v-card-actions>
        </v-card></v-form
      >
    </v-dialog>
  </v-row>
</template>

<script>
import api from '@/services/EventService.js'

export default {
  name: "NuovoUtente",

  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: function() {
    return {
      dialog: true,
      confermaReset: false,
      form: { email: null },
      rules: {
        required: (value) => {
          return !!value || this.$i18n.t("campoObbligatorio");
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$i18n.t("login.emailNonValida");
        },
      },
    };
  },
  methods: {
    async chiudi() {
      this.attivo = false;
      this.form.email= null;
      this.confermaReset = false;
      this.$emit("chiudiForm");
    },
    async resetPassword() {
       this.confermaReset = false;
      if (this.$refs.form.validate()) {
        // reset della password

        this.$isLoading(true);
        api
          .post("login/immatricolazioni/resetPassword", this.form)
          .then(() => {
            //alert(response.data);
          })
          .catch(() => {})
          .finally(() => {
            this.$isLoading(false);
            this.confermaReset = true;
          });

        //
      }
    },
    //
  },
  mounted: function() {},
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
// Reversed input variant
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 8px;
    }
  }
  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}

// Bonus "expand" variant
.v-input--expand .v-input__slot {
  // justify-content: space-between;
  .v-label {
    display: block;
    flex: 1;
  }
}
</style>
